<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: 'MEDICOS', link: '/doctor/doctor-list' },
          { label: 'PERFIL DEL MEDICO' }
        ]">
      </app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- Perfil -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-doctor-profile">
          <div class="profile-content">
            <img *ngIf="userImagen; else doctorIcon" class="profile-img" [src]="userImagen" alt="Foto del Medico">
            <ng-template #doctorIcon>
              <img class="profile-img" src="assets/images/doctor.png" alt="Doctor">
            </ng-template>
            <div class="profile-text">
              <div class="profile-name">{{ doctor.nombres }} {{ doctor.primerApellido }} {{ doctor.segundoApellido }}</div>
              <div class="profile-subtext">Rol: {{ rol }}</div>
            </div>
          </div>
        </div>

        <!-- FIRMA -->
        <div class="card card-signature" *ngIf="firmaDataUrl">
          <div class="card-header">
            <h2 class="card-title">FIRMA</h2>
          </div>
          <div class="card-body firma-wrapper">
            <img class="firma-img" [src]="firmaDataUrl" alt="Firma del Medico"/>
          </div>
        </div>
      </div>

      <!-- Detalles -->
      <div class="col-lg-8 col-md-12">
        <mat-accordion multi="true" class="details-accordion">

          <!-- Panel: Datos Generales -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon>person</mat-icon>DATOS GENERALES</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <div class="grid-2 gap-xl">
                <!-- Columna izquierda -->
                <div class="stack">
                  <div class="datos-item">
                    <span class="datos-label">NOMBRE COMPLETO</span>
                    <span class="datos-valor">{{ doctor.nombres }} {{ doctor.primerApellido }} {{ doctor.segundoApellido }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">USUARIO</span>
                    <span class="datos-valor">{{ doctor.usr }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">CORREO</span>
                    <span class="datos-valor">{{ doctor.email }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">TELEFONO</span>
                    <span class="datos-valor">{{ doctor.movil | formatMobile }}</span>
                  </div>
                </div>

                <!-- Columna derecha -->
                <div class="stack">
                  <div class="datos-item">
                    <span class="datos-label">DOMICILIO</span>
                    <span class="datos-valor">
                      {{ doctor.domicilio }}
                      <ng-container *ngIf="doctor.codigoPostal">, C.P. {{ doctor.codigoPostal }}</ng-container>
                    </span>
                  </div>

                  <div class="grid-2">
                    <div class="datos-item">
                      <span class="datos-label">ASENTAMIENTO</span>
                      <span class="datos-valor">{{ doctor.asentamiento }}</span>
                    </div>
                    <div class="datos-item">
                      <span class="datos-label">TIPO DE ASENTAMIENTO</span>
                      <span class="datos-valor">{{ doctor.tipoAsentamiento }}</span>
                    </div>
                  </div>

                  <div class="datos-item">
                    <span class="datos-label">CIUDAD / MUNICIPIO / ESTADO</span>
                    <span class="datos-valor">
                      {{ doctor.ciudad }} / {{ doctor.municipio }} / {{ doctor.estado }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Panel: Formacion -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon>school</mat-icon>FORMACION Y CEDULAS</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-content">
                <div class="stack">
                  <div class="datos-item">
                    <span class="datos-label">UNIVERSIDAD</span>
                    <span class="datos-valor">{{ doctor.universidad }}</span>
                  </div>

                  <div class="grid-2">
                    <div class="datos-item">
                      <span class="datos-label">CEDULA GENERAL</span>
                      <span class="datos-valor">{{ doctor.cedulaGeneral }}</span>
                    </div>
                    <div class="datos-item">
                      <span class="datos-label">CEDULA ESPECIALIDAD</span>
                      <span class="datos-valor">{{ doctor.cedulaEspecialidad }}</span>
                    </div>
                  </div>

                  <div class="datos-item">
                    <span class="datos-label">ESPECIALIDAD</span>
                    <span class="datos-valor">{{ doctor.especialidad }}</span>
                  </div>
                </div>
              </div>
          </mat-expansion-panel>

          <!-- Panel: Empresa / Horario -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon>business</mat-icon>EMPRESA Y HORARIO</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <div class="stack">
                <div class="grid-2">
                  <div class="datos-item">
                    <span class="datos-label">GRUPO EMPRESARIAL</span>
                    <span class="datos-valor">{{ doctor.grupoEmpresarial }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">SUCURSAL</span>
                    <span class="datos-valor">{{ doctor.sucursal }}</span>
                  </div>
                </div>

                <div class="datos-item">
                  <span class="datos-label">HORARIO</span>
                  <span class="datos-valor">{{ doctor.horario }}</span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Recetas -->
        <div class="card" *ngIf="userRole == UserRole.Admin || userRole == UserRole.Supervisor_Sucursales">
          <div class="card-header"><h2 class="card-title">RECETAS</h2></div>
          <div class="card-body">
            <app-prescription-by-id-doctor [idDoctor]="param" [idSucursal]="param2"></app-prescription-by-id-doctor>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
